// extracted by mini-css-extract-plugin
export default {"gamesGridView":"GamesGridView__gamesGridView--20p"};